/* Hero · Detail crop: the slide carousel for sections/hero-detail-crop.liquid. Loaded with defer.
   Slides after the first ship without a src (data-src / data-srcset). The next slide is warmed up once the page is
   idle, and the one before it too, unless the visitor has Save-Data on or a 2G connection. Arrow keys, the arrows,
   swipes and the theme editor's block selection all move between slides. */

if (!customElements.get('detail-hero')) {
  customElements.define('detail-hero', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-hdc-slide]')];
      this.panels = [...this.querySelectorAll('[data-hdc-panel]')];
      this.caps = [...this.querySelectorAll('[data-hdc-cap]')];
      this.counter = this.querySelector('[data-hdc-count]');
      this.imgs = this.slides.map(s => s.querySelector('img'));
      this.n = this.panels.length;
      this.i = 0;

      this.addEventListener('shopify:block:select', e => {
        const j = this.panels.indexOf(e.target.closest('[data-hdc-panel]'));
        if (j > -1) { this.stop(); this.go(j); }
      });
      if (this.n < 2) return;

      const c = navigator.connection;
      this.lean = !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
      if (!this.lean) {
        const warm = () => this.idle(() => this.load(this.i + 1));
        document.readyState === 'complete' ? warm() : addEventListener('load', warm, { once: true });
      }

      this.querySelector('[data-hdc-prev]')?.addEventListener('click', () => { this.stop(); this.go(this.i - 1); });
      this.querySelector('[data-hdc-next]')?.addEventListener('click', () => { this.stop(); this.go(this.i + 1); });
      this.addEventListener('keydown', e => {
        if (e.target.closest('input,textarea,select')) return;
        const d = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
        if (!d) return;
        e.preventDefault();
        this.stop();
        this.go(this.i + d);
      });

      let x0 = null;
      this.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', e => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { this.stop(); this.go(this.i + (dx < 0 ? 1 : -1)); }
        x0 = null;
      });
    }
    disconnectedCallback() { clearInterval(this.t); }
    stop() { clearInterval(this.t); }
    idle(fn) { 'requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 4000 }) : setTimeout(fn, 1500); }
    load(k) {
      const img = this.imgs[(k + this.n) % this.n];
      if (!img || !(img.dataset.srcset || img.dataset.src)) return;
      img.loading = 'eager';
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-src');
    }
    go(j) {
      this.i = (j + this.n) % this.n;
      this.load(this.i);
      if (!this.lean) this.idle(() => { this.load(this.i + 1); this.load(this.i - 1); });
      const set = (els, attr) => els.forEach((el, k) => {
        const on = k === this.i;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (attr) el.toggleAttribute('inert', !on);
      });
      set(this.slides);
      set(this.panels, true);
      set(this.caps);
      if (this.counter) this.counter.textContent = String(this.i + 1).padStart(2, '0');
    }
  });
}
